import AlertFailed from './AlertFailed';
import Fields from './Fields';
import FieldsSkeleton from './FieldsSkeleton';

interface CreditCardFormProps {
  children: React.ReactNode;
  hidden: boolean;
}

function CreditCardForm({ children, hidden }: CreditCardFormProps) {
  return (
    <form id="form-checkout" hidden={hidden}>
      {children}
    </form>
  );
}

CreditCardForm.Skeleton = FieldsSkeleton;
CreditCardForm.Fields = Fields;
CreditCardForm.AlertFailed = AlertFailed;

export default CreditCardForm;
